import PropTypes from "prop-types";
import { Link as RouterLink } from "react-router-dom";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";

import { styled } from "@mui/material/styles";
import { Box, Button, Link, Typography } from "@mui/material";

import useAuth from "../../../hooks/useAuth";

import { PATH_DASHBOARD } from "../../../routes/paths";

import MyAvatar from "../../../components/MyAvatar";
import { useState } from "react";

const RootStyle = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
  transition: theme.transitions.create("opacity", {
    duration: theme.transitions.duration.shorter,
  }),
}));

NavbarAccount.propTypes = {
  isCollapse: PropTypes.bool,
};

export default function NavbarAccount({ isCollapse }) {
  const [copyed, setCopyed] = useState(false);
  const { user } = useAuth();

  const copyUid = (e) => {
    const textArea = document.createElement("textarea");
    textArea.value = e;
    document.body.appendChild(textArea);
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);
    setCopyed(true);
  };

  return (
    <Link
      underline="none"
      color="inherit"
      component={RouterLink}
      to="#"
      // to={PATH_DASHBOARD.user.account}
      onMouseLeave={() => {
        let interval;
        interval = setTimeout(() => {
          setCopyed(false);
        }, 2000);
        return () => {
          clearInterval(interval);
        };
      }}
    >
      <RootStyle
        sx={{
          ...(isCollapse && {
            bgcolor: "transparent",
          }),
        }}
      >
        <MyAvatar />

        <Box
          sx={{
            ml: 2,
            transition: (theme) =>
              theme.transitions.create("width", {
                duration: theme.transitions.duration.shorter,
              }),
            ...(isCollapse && {
              ml: 0,
              width: 0,
              display: "none",
            }),
          }}
        >
          <Typography variant="subtitle2" noWrap>
            {`${user?.user?.firstName} ${user?.user?.lastName}`}
          </Typography>
          <Button
            style={{
              padding: 0,
              width: "100%",
              textTransform: "inherit",
              fontSize: "12px",
              color: "#707070",
            }}
            onClick={() => {
              copyUid(user?.user?.id);
            }}
          >
            <Box>
              {copyed ? (
                "Copied!"
              ) : (
                <Box display="flex" alignItems="center">
                  <Box
                    paddingRight="6px"
                    sx={{ fontSize: "12px", color: "#707070" }}
                  >
                    ID: {user?.user?.id}
                  </Box>
                  <ContentCopyIcon fontSize="16px" sx={{ color: "#707070" }} />
                </Box>
              )}
            </Box>
          </Button>
        </Box>
      </RootStyle>
    </Link>
  );
}
